export const METRIPORT_PRIMARY = "#748df0";
export const METRIPORT_PRIMARY_FADED = "#879ced";
export const METRIPORT_PRIMARY_FADED_CSS = {
  r: 135,
  g: 156,
  b: 237,
};
